import React, { useState, useMemo } from 'react';
import { ApolloProvider, ApolloClient, HttpLink, InMemoryCache } from '@apollo/client';
import type { CustomDimensions } from '@zillow/universal-analytics-react';
import { UniversalAnalyticsContextProvider } from '@zillow/universal-analytics-react';

import PropertySearchWrapper from './components/PropertySearchWrapper';

const getApolloClient = (gdpServiceUrl: string, serviceName: string) =>
    new ApolloClient({
        cache: new InMemoryCache(),
        link: new HttpLink({
            credentials: 'include',
            uri: gdpServiceUrl,
            headers: {
                'client-id': serviceName,
            },
        }),
    });

export interface HmimhwPropertySearchProps {
    publicConfigValues: {
        addressAutocompleteURL: string;
        gdpServiceUrl: string;
        zatlasEndpoint: string;
    };
    placementId: string;
    surfaceId: string;
    xConsumerUsername: string;
    isLightboxBackgroundLocked?: boolean;
    serviceName: string;
    setIsLightboxOpen?: (isOpen: boolean) => void;
    handleLightBoxDirectHit?: () => void;
    isCMS?: boolean;
}

const HmimhwPropertySearch = (props: HmimhwPropertySearchProps) => {
    const {
        publicConfigValues: { gdpServiceUrl },
        serviceName = 'hmimhw-property-search',
    } = props;

    const apolloClient = useMemo(() => getApolloClient(gdpServiceUrl, serviceName), [
        gdpServiceUrl,
        serviceName,
    ]);
    const [
        requiredCustomDimensions,
        setRequiredCustomDimensions,
    ] = useState<CustomDimensions | null>(null);

    return (
        <UniversalAnalyticsContextProvider
            options={{ shouldRequireCustomDimensions: true }}
            requiredCustomDimensions={requiredCustomDimensions || undefined}
        >
            <ApolloProvider client={apolloClient}>
                <PropertySearchWrapper
                    {...props}
                    setRequiredCustomDimensions={setRequiredCustomDimensions}
                />
            </ApolloProvider>
        </UniversalAnalyticsContextProvider>
    );
};

export default HmimhwPropertySearch;
